<page-toolbar [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!error">
  <mat-card appearance="outlined">
    <mat-card-title>Details:</mat-card-title>
    <mat-list>
      <mat-list-item>Error Code: {{error.code}}</mat-list-item>
      <mat-list-item>Method: {{error.method}}</mat-list-item>
      <mat-list-item>Route: {{error.route}}</mat-list-item>
      <mat-list-item>Date: {{error.created| date: 'dd.MM.yyyy'}}</mat-list-item>
      <mat-list-item>Query: {{error.query}}</mat-list-item>
      <mat-list-item>Parameter: {{error.params}}</mat-list-item>
    </mat-list>
    <mat-card appearance="outlined">
      <mat-card-title>Message:</mat-card-title>
      {{error.message}}
    </mat-card>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>User:</mat-card-title>
    <mat-list>
      <mat-list-item>Name: {{error.userName}}</mat-list-item>
      <mat-list-item>IP-Adresse: {{error.ip}}</mat-list-item>
      <mat-list-item>Id: {{error.userId}}</mat-list-item>
    </mat-list>
  </mat-card>
</page-content>
